import React, { Component } from 'react';
import PageHeader from "../../../hoc/PageHeader";
import Wrp from "../../../hoc/Wrp/Wrp";
import BreadCrumbsList from './list';
import Buttons from '../Buttons';
import ListIcons from '../ListIcons';
import VersionDetail from '../../../Containers/AddOnContainer/AddonDetails/VersionDetail';

class BreadCrumbs extends Component {
    
    componentDidMount = ()=>{
        this.updatePageTitle();
    }
    componentDidUpdate = (prevProps)=>{
        if(prevProps.breadCrumbsList!==this.props.breadCrumbsList){
            this.updatePageTitle();
        }
    }
    updatePageTitle = ()=>{
        const {breadCrumbsList} = this.props;
        let title = [];
        
        breadCrumbsList.backHistory.forEach((i)=>{
            title.push(i.name);
        });
        title.push(breadCrumbsList.pageTitle);
        // title.push(' | ShipCRM');
    
        document.title= title.join(' - ');
    }
    render () {
        const {breadCrumbsList} = this.props;
        // const params = this.props.match.params;
        let selectedTags = null;

if (
	this.props.selectedTags &&
	this.props.match &&
	this.props.match.url.includes('/tags/')
) {
	selectedTags = JSON.parse(this.props.selectedTags);
}
        const {wrap,children} = this.props;
        // let WrapHtml = (wrap === 'Default')?'PageHeader':'Wrp';
        // console.log('this.props',this.props.breadCrumbsList);
        
        return (
            (wrap === 'Default')?
            <PageHeader>
                <BreadCrumbsList breadCrumbsList={breadCrumbsList}/>
                {children}
                {
                    (selectedTags!==null) ?
                        // this.props.isTag === 'tags' ?
                            <div className="row justify-content-center flex-1">
                                <div className="col-12">
                                    <div className="form-group mb-0 row align-items-center justify-content-center">
                                        <div className="col-6 text-right">
                                            <label style={{whiteSpace: 'normal', fontSize:'11px'}} className="mb-0">Choose Windows to see Records of Tag <span className="badge badge-info"> {selectedTags ? selectedTags.tag_name : ''} </span> 
                                            </label>
                                        </div>
                                        <div className="col-5">
                                            <select onChange={this.props.tagsWindowChangeHandler} value={this.props.match.params.windowId} className="form-control form-control-sm">
                                                <option value=""></option>
                                                {
                                                  selectedTags && selectedTags.windows ?
                                                    selectedTags.windows.map((arr,ind) => {
                                                      return <option key={ind} windObj={JSON.stringify(arr)} value={arr.id}>{arr.display_name}</option>
                                                    })
                                                  : null
                                                }
                                            </select>
                                            {/* <Buttons key={'btn'} buttonList={this.props.breadCrumbsList.buttonList} /> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        // : null
                    : this.props.addonDetails !== null && this.props.isAddon === true ?
                        <div className="row justify-content-center flex-1">
                            <div className="col-12">
                                <div className="form-group mb-0 row align-items-center justify-content-center">
                                    <div className="col-6 text-right">
                                        <label style={{whiteSpace: 'normal', fontSize:'11px'}} className="mb-0">Choose Addon Version to see Records  
                                        </label>
                                    </div>
                                    <div className="col-5">
                                        <select onChange={e=>this.props.versionRedirect(e.target.value)} value={this.props.versionId} className="form-control form-control-sm">
                                            <option value=""></option>
                                            {
                                                this.props.addonDetails.versions.map((arr,ind) => {
                                                  return <option key={ind} windObj={JSON.stringify(arr)} value={arr.id}>{arr.version}</option>
                                                })
                                            }
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    : null
                }
               
                
                <div className="ml-md-auto py-2 py-md-0 padding_0 ">

                    {this.props.breadCrumbsList.activeFilterDisplay && 
                 
                        <Buttons key={'filter-btn'} buttonList={[this.props.breadCrumbsList.activeFilterDisplay]} />
                 
                    }
                    { this.props.breadCrumbsList.selectedTypeObj ?
                        <ListIcons dropDownList={this.props.breadCrumbsList.dropDownList} selectedTypeObj={this.props.breadCrumbsList.selectedTypeObj} activeView={this.props.tableRecords.gridView}/>
                    : null }
                    <Buttons
                      key={'selected-btn-' + ((this.props.breadCrumbsList.buttonList || []).map((b) => b && b.name).join('|'))}
                      buttonList={this.props.breadCrumbsList.buttonList || []}
                    />
                   
                    
                </div>                
            </PageHeader>
            :
            <Wrp>
                <BreadCrumbsList breadCrumbsList={breadCrumbsList}/>
                {
                    (selectedTags!==null) ?
                        // this.props.isTag === 'tags' ?
                            <div className="row justify-content-center flex-1">
                                <div className="col-12">
                                    <div className="form-group mb-0 row align-items-center justify-content-center">
                                        <div className="col-6 text-right">
                                            <label style={{whiteSpace: 'normal', fontSize:'11px'}} className="mb-0">Choose Windows to see Records of Tag <span className="badge badge-info"> {selectedTags ? selectedTags.tag_name : ''} </span> 
                                            </label>
                                        </div>
                                        <div className="col-5">
                                            <select onChange={this.props.tagsWindowChangeHandler} value={this.props.match.params.windowId} className="form-control form-control-sm">
                                                <option value=""></option>
                                                {
                                                  selectedTags && selectedTags.windows ?
                                                    selectedTags.windows.map((arr,ind) => {
                                                      return <option key={ind} windObj={JSON.stringify(arr)} value={arr.id}>{arr.display_name}</option>
                                                    })
                                                  : null
                                                }
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        // : null
                    : null
                }                
                <div className="ml-md-auto py-2 py-md-0 padding_0 ">
                    { this.props.breadCrumbsList.selectedTypeObj ?
                        <ListIcons dropDownList={this.props.breadCrumbsList.dropDownList} selectedTypeObj={this.props.breadCrumbsList.selectedTypeObj} />
                    : null }
                    <Buttons
                      key={'selectedtypeobj-btn-' + ((this.props.breadCrumbsList.buttonList || []).map((b) => b && b.name).join('|'))}
                      buttonList={this.props.breadCrumbsList.buttonList || []}
                    />
                    <label style={{whiteSpace: 'normal', fontSize:'11px'}} className="mb-0">
                        <span className="badge badge-info"> {VersionDetail.status} </span> 
                    </label>
                 </div>                
            </Wrp>            
            
        )
    }
}

BreadCrumbs.defaultProps = {
  wrap: 'Default',
  children:<></>
};

export default BreadCrumbs;